module.exports = __webpack_public_path__ + "static/media/diners.9368558e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/credit-cards/diners.png
// module id = 991
// module chunks = 0